module.exports = __webpack_public_path__ + "assets/img/6f2f31720efe243d95337f7cfe8c8196.svg";